import { AssetRequest, AssetRequestType } from '@atom/types/assetRequest';

// The asset whose stock a transfer draws from. SDDOT and ADOT transfers name
// it explicitly; the ARDOT 118 process moves the request's own asset.
export const getTransferFromAssetId = (request: AssetRequest): string => {
  switch (request?.type) {
    case AssetRequestType.SDDOT_INVENTORY_TRANSFER:
    case AssetRequestType.ADOT_INVENTORY_TRANSFER:
      return request.fromAssetId;
    case AssetRequestType.ARDOT_118_TRANSFER:
      return request.assetId;
    default:
      return null;
  }
};
